import React from 'react'
import "./About.css";
import {  Banner, Btn1 } from '../../Module_Exporter/Module_Exporter';
import {  about_page_data, website_routes } from '../../functions/DefaultValues';
import { Helmet } from 'react-helmet-async';



function About() {
  return (
    <>
    <Helmet>    
    <title>CodeSperix-About</title>
    </Helmet>
    <main id='about_page'  >
   <Banner className="AboutBanner"  t1={about_page_data.main_heading.t1} text={about_page_data.main_heading_sub_headline} t2={about_page_data.main_heading.t2} w={about_page_data.bar.w}  />
     <div className="about_container main_container">
      <div data-aos="fade-right" className=" about_image_container">
{/* <img src={About_image} alt="web development company" /> */}
      </div>
      <div data-aos="fade-left" className="about_info">
        <h2 className="heading">{about_page_data.heading()}</h2>
        <div>{about_page_data.about_us()}</div>
        <Btn1 cl="about_page_btn" value="Contact US" url={website_routes.contact_page}/>
      </div>
     </div>
    </main>
    </>
  )
}

export default About